export default __webpack_public_path__ + "static/media/Person.303b3486.svg";